import React from "react";
import {Row,Col} from "react-bootstrap"
import { useSelector} from "react-redux"

const UczestnikInfo  = (props) => {
    const uczestnik = useSelector((magazyn) => magazyn.uczestnik)
    
    return  (
        <Row className= "uczestnik">
            <Row>
                <Col xs={3}><h3>Nazwisko</h3></Col>
                <Col xs={2}><h3>Imię</h3></Col>
            </Row> 
            <Row key={uczestnik.id_konkursu}>
                <Col xs={3}><span className="wyroznienie">{uczestnik.nazwisko}</span></Col>
                <Col xs={2}><span className="wyroznienie">{uczestnik.imie}</span></Col>
            </Row> 
            )
        </Row>
    )       
}
 
export default UczestnikInfo